'use client';

import { c as _c } from "react/compiler-runtime";
import * as SubframeCore from '@subframe/core';
import { FeatherChevronDown } from '@subframe/core';
import * as Flags from 'country-flag-icons/react/3x2';
import React, { useEffect, useMemo, useState } from 'react';
import * as SubframeUtils from '../utils';
import { phoneCountryConfigs } from '@/shared/utils/contato';
interface PhoneInputProps {
  label?: string;
  helpText?: string;
  variant?: 'default' | 'error';
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  countryCode?: string;
  onCountryCodeChange?: (code: string) => void;
  onValueChange?: (value: {
    raw: string;
    formatted: string;
    countryCode: string;
  }) => void;
  onBlur?: () => void;
}
export function PhoneInput(t0) {
  const $ = _c(63);
  const {
    label: t1,
    helpText,
    variant: t2,
    value,
    onChange,
    disabled: t3,
    countryCode: externalCountryCode,
    onCountryCodeChange,
    onValueChange,
    onBlur
  } = t0;
  const label = t1 === undefined ? "WhatsApp" : t1;
  const variant = t2 === undefined ? "default" : t2;
  const disabled = t3 === undefined ? false : t3;
  const [internalCountryCode, setInternalCountryCode] = useState("+55");
  const countryCode = externalCountryCode || internalCountryCode;
  let t4;
  if ($[0] !== countryCode) {
    t4 = phoneCountryConfigs.find(c => c.code === countryCode) || phoneCountryConfigs[0];
    $[0] = countryCode;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const selectedCountry = t4;
  let t5;
  if ($[2] !== countryCode || $[3] !== selectedCountry || $[4] !== value) {
    bb0: {
      if (!value) {
        t5 = "";
        break bb0;
      }
      const cleanValue = value.replace(/\D/g, "");
      const prefix = countryCode.replace("+", "");
      if (cleanValue.startsWith(prefix) && cleanValue.length > 8) {
        const localValue = cleanValue.slice(prefix.length);
        t5 = selectedCountry.mask(localValue);
        break bb0;
      }
      let t6;
      if ($[6] !== selectedCountry || $[7] !== value) {
        t6 = selectedCountry.mask(value);
        $[6] = selectedCountry;
        $[7] = value;
        $[8] = t6;
      } else {
        t6 = $[8];
      }
      t5 = t6;
    }
    $[2] = countryCode;
    $[3] = selectedCountry;
    $[4] = value;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const displayValue = t5;
  let t6;
  if ($[9] !== externalCountryCode || $[10] !== onChange || $[11] !== selectedCountry || $[12] !== value) {
    t6 = () => {
      const cleanValue_0 = value?.replace(/\D/g, "") || "";
      if (cleanValue_0.startsWith("55") && cleanValue_0.length >= 12 && !externalCountryCode) {
        setInternalCountryCode("+55");
        const rest = cleanValue_0.slice(2);
        onChange(selectedCountry.mask(rest));
      }
    };
    $[9] = externalCountryCode;
    $[10] = onChange;
    $[11] = selectedCountry;
    $[12] = value;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  useEffect(t6, t7);
  let t8;
  if ($[15] !== onChange || $[16] !== onCountryCodeChange) {
    t8 = newCode => {
      if (onCountryCodeChange) {
        onCountryCodeChange(newCode);
      } else {
        setInternalCountryCode(newCode);
      }
      onChange("");
    };
    $[15] = onChange;
    $[16] = onCountryCodeChange;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const handleCountryChange = t8;
  let t9;
  if ($[18] !== countryCode || $[19] !== onChange || $[20] !== onValueChange || $[21] !== selectedCountry) {
    t9 = e => {
      let inputValue = e.target.value;
      const cleanInput = inputValue.replace(/\D/g, "");
      const prefix_0 = countryCode.replace("+", "");
      if (cleanInput.startsWith(prefix_0) && cleanInput.length > 10) {
        inputValue = cleanInput.slice(prefix_0.length);
      }
      const maskedValue = selectedCountry.mask(inputValue);
      onChange(maskedValue);
      if (onValueChange) {
        const cleanDigits = maskedValue.replace(/\D/g, "");
        onValueChange({
          raw: `${prefix_0}${cleanDigits}`,
          formatted: `${countryCode} ${maskedValue}`,
          countryCode
        });
      }
    };
    $[18] = countryCode;
    $[19] = onChange;
    $[20] = onValueChange;
    $[21] = selectedCountry;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const handlePhoneChange = t9;
  const getFlagComponent = _temp;
  let t10;
  if ($[23] !== label) {
    t10 = label && <span className="text-caption-bold font-caption-bold text-default-font">{label}</span>;
    $[23] = label;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== variant) {
    t11 = SubframeUtils.twClassNames("relative flex h-10 w-full items-center rounded-[8px] border border-solid transition-all duration-200", {
      "border-neutral-300": variant === "default",
      "border-error-600": variant === "error",
      "focus-within:border-brand-600 focus-within:ring-brand-600/10 focus-within:ring-4": variant === "default",
      "focus-within:border-error-600 focus-within:ring-error-600/10 focus-within:ring-4": variant === "error"
    });
    $[25] = variant;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== disabled) {
    t12 = SubframeUtils.twClassNames("flex h-full items-center gap-1.5 rounded-l-[8px] border-r border-solid border-neutral-200 bg-white px-3 transition-colors hover:bg-neutral-50", {
      "cursor-not-allowed opacity-50": disabled
    });
    $[27] = disabled;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  let t14;
  if ($[29] !== selectedCountry.code) {
    t13 = <div className="flex items-center justify-center overflow-hidden rounded-full">{getFlagComponent(selectedCountry.code)}</div>;
    t14 = <span className="text-caption font-caption text-default-font">{selectedCountry.code}</span>;
    $[29] = selectedCountry.code;
    $[30] = t13;
    $[31] = t14;
  } else {
    t13 = $[30];
    t14 = $[31];
  }
  let t15;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <FeatherChevronDown className="text-subtext-color h-3.5 w-3.5" />;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== disabled || $[34] !== t12 || $[35] !== t13 || $[36] !== t14) {
    t16 = <SubframeCore.DropdownMenu.Trigger asChild={true}><button type="button" disabled={disabled} className={t12}>{t13}{t14}{t15}</button></SubframeCore.DropdownMenu.Trigger>;
    $[33] = disabled;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== handleCountryChange) {
    t17 = phoneCountryConfigs.map(country => <SubframeCore.DropdownMenu.Item key={country.code} onSelect={() => handleCountryChange(country.code)} className="text-body font-body text-default-font flex cursor-pointer items-center gap-3 rounded px-3 py-2 transition-colors outline-none hover:bg-neutral-50 focus:bg-neutral-50"><div className="flex shrink-0 items-center justify-center overflow-hidden rounded-full">{getFlagComponent(country.code)}</div><div className="flex flex-1 items-center justify-between gap-2"><span className="text-body font-body text-default-font">{country.label}</span><span className="text-caption text-subtext-color">{country.code}</span></div></SubframeCore.DropdownMenu.Item>);
    $[38] = handleCountryChange;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t17) {
    t18 = <SubframeCore.DropdownMenu.Portal><SubframeCore.DropdownMenu.Content align="start" className="z-50 w-64 min-w-[200px] rounded-[8px] border border-solid border-neutral-200 bg-white p-1 shadow-lg">{t17}</SubframeCore.DropdownMenu.Content></SubframeCore.DropdownMenu.Portal>;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t16 || $[43] !== t18) {
    t19 = <SubframeCore.DropdownMenu.Root>{t16}{t18}</SubframeCore.DropdownMenu.Root>;
    $[42] = t16;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  const t20 = selectedCountry.placeholder;
  let t21;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = SubframeUtils.twClassNames("text-body font-body text-default-font h-full flex-1 rounded-r-[8px] border-0 bg-white py-2 pr-3 pl-3 placeholder:text-neutral-400 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50");
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== disabled || $[47] !== displayValue || $[48] !== handlePhoneChange || $[49] !== onBlur || $[50] !== selectedCountry.placeholder) {
    t22 = <input type="tel" placeholder={t20} value={displayValue} onChange={handlePhoneChange} onBlur={onBlur} disabled={disabled} className={t21} />;
    $[46] = disabled;
    $[47] = displayValue;
    $[48] = handlePhoneChange;
    $[49] = onBlur;
    $[50] = selectedCountry.placeholder;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t11 || $[53] !== t19 || $[54] !== t22) {
    t23 = <div className={t11}>{t19}{t22}</div>;
    $[52] = t11;
    $[53] = t19;
    $[54] = t22;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== helpText || $[57] !== variant) {
    t24 = helpText && <span className={SubframeUtils.twClassNames("text-caption font-caption", {
      "text-error-600": variant === "error",
      "text-subtext-color": variant === "default"
    })}>{helpText}</span>;
    $[56] = helpText;
    $[57] = variant;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  if ($[59] !== t10 || $[60] !== t23 || $[61] !== t24) {
    t25 = <div className="flex flex-col gap-1.5">{t10}{t23}{t24}</div>;
    $[59] = t10;
    $[60] = t23;
    $[61] = t24;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  return t25;
}
function _temp(countryCode_0) {
  const codeMap = {
    "+55": "BR",
    "+1": "US",
    "+351": "PT",
    "+44": "GB",
    "+34": "ES",
    "+33": "FR",
    "+49": "DE",
    "+39": "IT",
    "+54": "AR",
    "+56": "CL",
    "+52": "MX"
  };
  const isoCode = codeMap[countryCode_0] || "BR";
  const Flag = Flags[isoCode];
  return <Flag className="h-4 w-4" />;
}